import { useEffect, useState } from 'react';
import GlobalStyle from '@/styles/GlobalStyle';
import Router from '@/routes/Router';
import Header from './components/Header';
import 'antd/dist/reset.css';
import Footer from './components/Footer';
import FloatButton from './components/FloatButton';
import { usePageView } from '@/hooks/usePageView';
import { useLocation } from 'react-router-dom';
import { setWithExpiry, getWithExpiry } from '@/utils/storage';
import { isMobile } from '@/utils/isMobile';

function App() {
  const location = useLocation();
  const path = location.pathname;
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    setIsMobileDevice(isMobile());
  }, []);

  // ✅ 리뷰 페이지 && 모바일인 경우에만 헤더 숨김
  const isHeaderVisible = !(
    isMobileDevice &&
    (path === '/review' || /^\/review\/\d+$/.test(path) || path === '/reading')
  );

  useEffect(() => {
    const kakaoKey = import.meta.env.VITE_KAKAO_JS;
    if (window.Kakao && !window.Kakao.isInitialized()) {
      window.Kakao.init(kakaoKey);
    }

    const params = new URLSearchParams(location.search);
    const affiliated = params.get('affiliated');

    const existing = getWithExpiry('affiliated');

    if (affiliated && !existing) {
      setWithExpiry('affiliated', affiliated, 24 * 60 * 60 * 1000); // 24시간 TTL
    }
  }, [location.search]);

  usePageView();
  return (
    <>
      {isHeaderVisible && <Header />}
      <GlobalStyle />
      <Router />
      <Footer />
      <FloatButton />
    </>
  );
}

export default App;
